<template>
    <div>
        <card-header icon="fa-calendar-lines-pen" title="Session Scheduler"/>

        <card-body v-if="conference.id">
            <webix-scheduler :conf="conference"/>
        </card-body>

        <card-footer>
            <i class="fal fa-info-circle mr-2"></i>
            Double-click a slot to create a new event/session.
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from "@/http_client";
    import WebixScheduler from "./WebixScheduler";

    export default {
        components: {WebixScheduler, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function() {
            return {
                conference: {}
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                });
            }
        },
        watch: {},
        mounted: function() {
            this.loadConference();
        }
    };
</script>

<style lang="scss">
    .webix-test {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>
